import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { ReportsPage } from "./pages/ReportsPage";
import { InformeVehicularPage } from "./pages/InformeVehicularPage";
import { TalleresPage } from "./pages/TalleresPage";
import { ProveedoresPage } from "./pages/ProveedoresPage";
import { PropietariosPage } from "./pages/PropietariosPage";
import { PlataformaPage } from "./pages/PlataformaPage";
import { FAQPage } from "./pages/FAQPage";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/reportes" element={<ReportsPage />} />
            <Route path="/informe" element={<InformeVehicularPage />} />
            <Route path="/talleres" element={<TalleresPage />} />
            <Route path="/proveedores" element={<ProveedoresPage />} />
            <Route path="/propietarios" element={<PropietariosPage />} />
            <Route path="/plataforma" element={<PlataformaPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/nosotros" element={<Home />} />
            <Route path="/contacto" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
